import { render } from "./Fees.vue?vue&type=template&id=03d515fc&scoped=true"
import script from "./Fees.vue?vue&type=script&lang=js"
export * from "./Fees.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-03d515fc"

export default script